import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnSG: CultureInfo = {
  name: 'en-SG',
  displayName: 'English (Singapore)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-SG',
  parent: CultureInfoEn
};
